
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { GDAuthInterface } from '../../model/gd-auth';
import { Subject } from 'rxjs';
import { AttendanceBloc } from '../../bloc/hr/attendance/attendance.bloc';


@Injectable()
export class HomeFeedStateProvider {

  public SFGOAuth = new Subject<GDAuthInterface>();
  public teamMates = new Subject<Array<any>>();
  public todayTask = new Subject<Array<any>>();
  public announcement = new Subject<Array<any>>();
  public myCompany = new Subject<any>();
  public showPosting = new Subject<boolean>();

  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    public storage: Storage,
    public attendanceBloc: AttendanceBloc
  ) {

  }

  async getAuth() {
    try {
      let auth = await this.storage.get('SFGoAuth');
      auth = auth ? JSON.parse(auth) : null;
      this.SFGOAuth.next(auth);
    }
    catch (error) {
      console.log(error)
    }
  }

  async getMyCompany() {
    try {
      let company = await this.storage.get('company');
      if (company) {
        company = JSON.parse(company);
        this.myCompany.next(company);
      }
    }
    catch (error) {
      console.log('company', error);
    }
  }

  async getTeamMates() {
    try {
      let teamMates = await this.storage.get('teammate');
      if (teamMates) {
        teamMates = JSON.parse(teamMates);
        this.teamMates.next(teamMates);
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  async getTodayTask() {
    try {
      let todayTask = await this.storage.get('todayTask');
      if (todayTask) {
        todayTask = JSON.parse(todayTask);
        this.todayTask.next(todayTask);
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  async getAnnouncement() {
    try {
      let announcement = await this.storage.get('announcement');
      if (announcement) {
        announcement = JSON.parse(announcement);
        this.announcement.next(announcement);
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  async getPostSetting() {
    try {
      let GDSetting = await this.attendanceBloc.getAttendanceSetting();;
      GDSetting = GDSetting ? GDSetting : null;
      if (GDSetting) {
        let isShow = GDSetting.hasOwnProperty('showPosting') ? GDSetting.showPosting : true;
        this.showPosting.next(isShow);
      }
    } catch (error) {
      this.showPosting.next(true);
    }
  }
}





// WEBPACK FOOTER //
// ./src/providers/management-state/homefeed.state.ts